import React, { Component } from "react";
import FeedNav from "./FeedNav";
import Nav from "./Nav";
import Alerts from "./Alerts";

class Notifications extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: this.props.user,
    };
  }

  render() {
    return (
      <React.Fragment>
        <Nav user={this.state.user} />
        <div className="feed">
          <div className="row feed-container">
            <div className="col-md-3 col-lg-2 col-sm-12 feed-left">
              <FeedNav user={this.props.user} />
            </div>
            <div className="col-md-9 col-lg-10 col-sm-12 feed-center">
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "flex-start",
                  minHeight: "60vh",
                  padding: "20px",
                }}
              >
                <div
                  className="mob-frnd-re-cont"
                  style={{
                    width: "100%",
                    backgroundColor: "#fff",
                    borderRadius: "12px",
                    padding: "40px",
                  }}
                >
                  <h2
                    style={{
                      marginBottom: "20px",
                      fontSize: "22px",
                      fontWeight: "700",
                      color: "#000",
                      borderBottom: "2px solid #ff9500",
                      paddingBottom: "12px",
                      display: "inline-block",
                    }}
                  >
                    Notifications
                  </h2>
                  <div style={{ marginTop: "20px" }}>
                    <Alerts user={this.props.user} isFullPage={true} onAlertsChange={() => this.forceUpdate()} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }

  componentDidMount() {
    if (this.props.user) {
      this.setState({ user: this.props.user });
    }
  }
}

export default Notifications;    